/**
 * Cổng ra platform của Alert — Prompt.md §19.
 *
 * Đây là ranh giới mà §18 dựng lên ("không phát Speech trực tiếp từ PostureEngine"): `alert-core`
 * quyết định *có nhắc hay không và nhắc câu gì*, provider quyết định *phát ra bằng cách nào*. Khi
 * lên React Native, chỉ file cài đặt interface này bị thay.
 */

import type { AlertMessageKey } from "@studystraight/shared-types";

export interface AlertProvider {
  /**
   * Phát câu nhắc. Phải **resolve** chứ không reject khi thiết bị thiếu giọng vi-VN —
   * AlertEngine đã tiêu một lần cooldown cho câu này, ném lỗi lên chỉ làm mất luôn cả cảnh báo.
   *
   * Nhận cả `key` bên cạnh `text` để provider chọn được file audio thu sẵn. Truyền key thay vì để
   * provider map ngược từ chuỗi tiếng Việt sang tên file: map ngược sẽ hỏng im lặng ngay lần đầu ai
   * sửa một dấu phẩy trong `alertMessages`, và hỏng theo kiểu "vẫn có tiếng, nhưng sai câu".
   */
  speak(text: string, key: AlertMessageKey): Promise<void>;
  chime(): Promise<void>;
  /** No-op ở nơi không hỗ trợ (iOS Safari) — đó là hành vi mong đợi, không phải lỗi. */
  vibrate(pattern: readonly number[]): void;
  /** `false` khi audio chưa được unlock (§19) → engine vẫn quyết định nhưng UI hiện dạng chữ. */
  isAvailable(): boolean;
}

/**
 * Provider rỗng — dùng cho test và cho `decide()`-only.
 *
 * Có sẵn ở đây thay vì để mỗi test tự viết lại: một provider giả viết sai (ví dụ `speak` throw)
 * biến lỗi của test thành lỗi của engine.
 */
export const silentAlertProvider: AlertProvider = {
  speak: () => Promise.resolve(),
  chime: () => Promise.resolve(),
  vibrate: () => {},
  isAvailable: () => false,
};
